import {
    ALLMA_JOB_TYPE_ADDITIVE_PLANTING,
    ALLMA_JOB_TYPE_DITCH_CLEARING,
    ALLMA_JOB_TYPE_FERTILIZATION,
    ALLMA_JOB_TYPE_HOGGER,
    ALLMA_JOB_TYPE_PLANTATION_CONTROL,
    ALLMA_JOB_TYPE_PLANTING,
    ALLMA_JOB_TYPE_PRECLEARING_FELLING,
    ALLMA_JOB_TYPE_PRECLEARING_THINNING,
    ALLMA_JOB_TYPE_SCARIFICATION,
    ALLMA_JOB_TYPE_SCARIFICATION_WITH_EXCAVATOR,
    ALLMA_JOB_TYPE_SCARIFICATION_WITH_SOWING,
    ALLMA_JOB_TYPE_SPRAYING,
    ALLMA_JOB_TYPE_STEMPRUNING,
    ALLMA_JOB_TYPE_THINNING,
    ALLMA_JOB_TYPE_TRACK_REMOVING,
    ALLMA_JOB_TYPE_YOUNG_TREE_CARE
} from "~/constants/allmaJobs";

export const SALES_ORDER_TYPE_GROUND_PREPARATION = 1 // Markberedning
export const SALES_ORDER_TYPE_YOUNG_TREE_CARE = 2 // Ungskogpleie
export const SALES_ORDER_TYPE_PLANTING = 3 // Planting
export const SALES_ORDER_TYPE_SPRAYING = 4 // Sproyting
export const SALES_ORDER_TYPE_DIGGING = 5 // Gravearbeider
export const SALES_ORDER_TYPE_ADMINISTRATION = 6 // ForvaltningDrift
export const SALES_ORDER_TYPE_STEM_PRUNING = 7 // StammeKvisting
export const SALES_ORDER_TYPE_PLANT_SALE = 8 // Plantesalg
export const SALES_ORDER_TYPE_ADDITIVE_PLANTING = 9 // Suppleringsplanting
export const SALES_ORDER_TYPE_PLANTATION_CONTROL = 10 // Plantefeltkontroll
export const SALES_ORDER_TYPE_NO_PROPERTY = 11 // IngenEiendom
export const SALES_ORDER_TYPE_FERTILIZATION = 12 // Gjodsling
export const SALES_ORDER_TYPE_PRE_CLEARING_BEFORE_FINAL_FELLING = 13 // ForhandsryddingForSluttavvirkning
export const SALES_ORDER_TYPE_PRE_CLEARING_BEFORE_FINAL_THINNING = 14 // ForhandsryddingForTynning
export const SALES_ORDER_TYPE_GROUND_PREPARATION_WITH_EXCAVATOR = 15 // MarkberedningMedGravemaskin
export const SALES_ORDER_TYPE_GROUND_PREPARATION_WITH_SOWING = 16 // MarkberedningMedSaing
export const SALES_ORDER_TYPE_LOGGING = 20 // Hogst
export const SALES_ORDER_TYPE_THINNING = 30 // Tynning
export const SALES_ORDER_TYPE_BIO_GROT_HELTRE = 40 // BioGrotHeltre
export const SALES_ORDER_TYPE_ROAD_PLANNER = 41 // Veiplanlegger
export const SALES_ORDER_TYPE_TRACK_REPAIR = 50 // Sporskade

export const getSalesOrderTypeFromAllmaJobType = (allmaJobTypeNumber: string): number => {
    switch (allmaJobTypeNumber) {
        case ALLMA_JOB_TYPE_PRECLEARING_FELLING:
            return SALES_ORDER_TYPE_PRE_CLEARING_BEFORE_FINAL_FELLING
        case ALLMA_JOB_TYPE_PRECLEARING_THINNING:
            return SALES_ORDER_TYPE_PRE_CLEARING_BEFORE_FINAL_THINNING
        case ALLMA_JOB_TYPE_FERTILIZATION:
            return SALES_ORDER_TYPE_FERTILIZATION
        case ALLMA_JOB_TYPE_DITCH_CLEARING:
            return SALES_ORDER_TYPE_DIGGING
        case ALLMA_JOB_TYPE_HOGGER:
            return SALES_ORDER_TYPE_LOGGING
        case ALLMA_JOB_TYPE_SCARIFICATION:
            return SALES_ORDER_TYPE_GROUND_PREPARATION
        case ALLMA_JOB_TYPE_SCARIFICATION_WITH_EXCAVATOR:
            return SALES_ORDER_TYPE_GROUND_PREPARATION_WITH_EXCAVATOR
        case ALLMA_JOB_TYPE_PLANTATION_CONTROL:
            return SALES_ORDER_TYPE_PLANTATION_CONTROL
        case ALLMA_JOB_TYPE_PLANTING:
            return SALES_ORDER_TYPE_PLANTING
        case ALLMA_JOB_TYPE_TRACK_REMOVING:
            return SALES_ORDER_TYPE_TRACK_REPAIR
        case ALLMA_JOB_TYPE_SPRAYING:
            return SALES_ORDER_TYPE_SPRAYING
        case ALLMA_JOB_TYPE_STEMPRUNING:
            return SALES_ORDER_TYPE_STEM_PRUNING
        case ALLMA_JOB_TYPE_ADDITIVE_PLANTING:
            return SALES_ORDER_TYPE_ADDITIVE_PLANTING
        case ALLMA_JOB_TYPE_THINNING:
            return SALES_ORDER_TYPE_THINNING
        case ALLMA_JOB_TYPE_YOUNG_TREE_CARE:
            return SALES_ORDER_TYPE_YOUNG_TREE_CARE
        case ALLMA_JOB_TYPE_SCARIFICATION_WITH_SOWING:
            return SALES_ORDER_TYPE_GROUND_PREPARATION_WITH_SOWING
        default:
            throw new Error(`Unknown Allma job type ${allmaJobTypeNumber}`)
    }
}

